import {
  CLEAR_ERROR_LOGIN,
  SET_CURRENT_USER_START,
  SET_CURRENT_USER_ERROR,
  SET_CURRENT_USER,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_ERROR,
} from '../actions/types';

const initialState = {
  loading: false,
  loggedUser: {},
  validToken: false,
  error: undefined,
};

const booleanActionPayload = (payload) => {
  if (payload) {
    return true;
  } else {
    return false;
  }
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const loginStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const loginError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const login = (state, action) => {
  return {
    ...state,
    loading: false,
    validToken: booleanActionPayload(action.payload),
    loggedUser: action.payload,
  };
};

const changePasswordStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const changePasswordError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const changePassword = (state, action) => {
  return {
    ...state,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return login(state, action);
    case SET_CURRENT_USER_START:
      return loginStart(state);
    case SET_CURRENT_USER_ERROR:
      return loginError(state, action);

    case CHANGE_PASSWORD:
      return changePassword(state, action);
    case CHANGE_PASSWORD_START:
      return changePasswordStart(state);
    case CHANGE_PASSWORD_ERROR:
      return changePasswordError(state, action);

    case CLEAR_ERROR_LOGIN:
      return clearError(state);

    default:
      return state;
  }
}
